module.exports = __webpack_public_path__ + "03_glasses_black.1a1fc57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/03_glasses_black.png
// module id = 2KTM
// module chunks = 0